import type { FaireProductEntity } from "../../entity_types/product";

export const p_c7ew1m4vg5: FaireProductEntity = {
  token: "p_c7ew1m4vg5",
  type: "product",
  name: "Nighty Nighty KidSafe Essential Oil Blend Roll-On 10mL",
  brandToken: "b_3z46kjdoak",
  brandName: "Plant Therapy",
  imageUrl:
    "https://cdn.faire.com/fastly/7a5d6af5bcd6585388e225e13721ef5e5cfdafcd6128efeb6e67b9d0bdc4c43e.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b6c1f797b6acf086824b8822fe2e12cf4fe85da74d47b75f1a85cb9d1b424c2.webp",
    "https://cdn.faire.com/fastly/5c5db313d3809bf432d444ec7b7f2558d08cf6c96056249292fe1e6d610f4fea.jpeg",
    "https://cdn.faire.com/fastly/a1b55641c115a3855f357e36ad74c3103c42e51e0e534faed376fe481da4e4f3.webp",
    "https://cdn.faire.com/fastly/d1c521af281d148a3dc9c7d3b5b193bd7f4c98bcba484276b93cf7d3b9f454df.jpeg",
    "https://cdn.faire.com/fastly/ffa1315000b73f275a2139ec77c888a2d337f9f53d6c928cabc85ebee9b6f57c.webp",
    "https://cdn.faire.com/fastly/436d301469a32ac6617199e310fbe5f2f8231de7a490c842373bd7a84588a9e3.jpeg",
    "https://cdn.faire.com/fastly/9dbc91eaa8df18025cbb134131369af742af006b2d43a31b155928cb731e2098.webp",
    "https://cdn.faire.com/fastly/313930f10281190c4cc2bdcc019929aa5e24fbdfa415cb693a2dd6efcd465cb4.webp",
    "https://cdn.faire.com/fastly/da4ddabb69b6f79e7764e812eeba65a2f5cf8ab538bd503d50f3d2e049537756.webp",
    "https://cdn.faire.com/fastly/55d3ebb6fae836a49bc7416132287a90a0f908622fc69524ab451107f0e0ccac.jpeg",
  ],
  priceDollars: 6,
  description:
    "Nighty Night is designed to create an overall calming atmosphere to help lure kids into a restful slumber. Each essential oil that makes up Nighty Night was carefully chosen to not only be safe, but effective when trying to create an atmosphere that is ideal for children to fall asleep. The blend is tranquil, warming, balancing, relaxing, and supports clear respiration, which is the perfect formula to calm little ones to help them fall asleep and stay asleep. A parent’s favorite and every child’s dream, Nighty Night is the ideal addition to your child’s bedtime routine.",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:29.234Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
